(() => {
  if (window.__jfAmazonOutboundTracking || window.Shopify?.designMode) return;
  window.__jfAmazonOutboundTracking = true;

  const amazonHost = /^(?:[a-z0-9-]+\.)*amazon\.(?:com|ca|co\.uk|de|fr|it|es|co\.jp|com\.au|in|com\.mx|com\.br|nl|se|pl|com\.be|ie|com\.tr|ae|sa|eg|sg|co\.za)$/i;
  const shortHost = /^(?:www\.)?amzn\.(?:to|asia|eu)$/i;

  function track(event) {
    if (!event.isTrusted) return;
    if (event.type === 'click' && event.button !== 0) return;
    if (event.type === 'auxclick' && event.button !== 1) return;

    const anchor = event.composedPath().find(node => node instanceof HTMLAnchorElement);
    if (!anchor) return;

    let url;
    try {
      url = new URL(anchor.href, location.href);
    } catch {
      return;
    }
    if (!/^https?:$/.test(url.protocol)) return;
    if (!amazonHost.test(url.hostname) && !shortHost.test(url.hostname)) return;

    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return;
    if (typeof window.gtag !== 'function') return;

    const parameters = {
      send_to: 'G-X8MPYHG7EQ',
      transport_type: 'beacon',
      link_domain: url.hostname,
      link_url: url.origin + url.pathname,
      outbound: true
    };
    const asin = url.pathname.match(/\/(?:dp|gp\/product)\/([a-z0-9]{10})(?:\/|$)/i);
    if (asin) parameters.asin = asin[1].toUpperCase();

    window.gtag('event', 'amazon_outbound_click', parameters);
  }

  window.addEventListener('click', track, { capture: true, passive: true });
  window.addEventListener('auxclick', track, { capture: true, passive: true });
})();
